/**
 * 股票信息
 */

import {quoteUrl} from '../../config/config'


export default {
  /**
   * 获取股票资讯
   */
  async getStockInfos(
    code: string,
    market: number,
    pageNumber: number,
    pageSize: number,
  ): Promise<null | {
    condition: string
    news: Array<object>
  }> {
    return $.ajax({
      url: `${quoteUrl.getPath('zixun')}comm/wap/getListInfo?cb=callback`,
      type: "GET",
      data:{
        client:"wap",
        type:'1,20',
        pageIndex:pageNumber,
        pageSize:pageSize,
        mTypeAndCode:market+'.'+code,

      },
      dataType: "jsonp",
    }).then((v) => {
      if (v.success == 1 || v.code == 1) {
        return v.data.list
      } else {
        return null
      }
    })
  },
   /**
   * 获取股票公告
   */
  async getStockNotices(
    code: string,
    market: number,
    pageNumber: number,
    pageSize: number,
    isBK:boolean
  ): Promise<null | {
    condition: string
    news: Array<object>
  }> {
    let params = {}
    if(isBK){
      params = {
        bk_code:code
      }
    }else{
      params = {
        market_code:market,
        stock_list:code
      }
    }
    return $.ajax({
      url: "//np-anotice-stock.eastmoney.com/api/security/ann?cb=?",
      type: "GET",
      data:{
        client_source:"wap",
        page_index:pageNumber,
        page_size:pageSize,
        ...params,
      },
      dataType: "jsonp",
    }).then((v) => {
      if (v.success == 1 || v.code == 1) {
        return v.data.list
      } else {
        return null
      }
    })
  },
   /**
   * 获取股票研报
   */
  async getStockReports(
    code: string,
    market: number,
    pageNumber: number,
    pageSize: number,
    isBK:boolean
  ): Promise<null | {
    condition: string
    news: Array<object>
  }> {
    let params = {}
    if(isBK){
      params = {
        bk_code:code
      }
    }else{
      params = {
        stock_list:market+"."+code
      }
    }
    return $.ajax({
      url: "//np-areport-wap.eastmoney.com/api/security/rep?cb=?",
      type: "GET",
      data:{
        client_source:"wap",
        page_index:pageNumber,
        page_size:pageSize,
        report_type:"0,1",
        ...params,
      },
      dataType: "jsonp",
    }).then((v) => {
      if (v.success == 1 || v.code == 1) {
        return v.data.list
      } else {
        return null
      }
    })
  },
   /**
   * 获取股票公告（返回全数据）
   */
  async getStockNotices_new(
    code: string,
    market: number,
    pageNumber: number,
    pageSize: number,
    isBK:boolean
  ): Promise<null | {
    condition: string
    news: Array<object>
  }> {


    // 指数类以SH000除了SH000300以外请求code都为000001,SZ399开头请求code为399001
    // 8.8新增逻辑：8.8版本码表新增东方财富全A指数800000和800001的股票代码，以000001请求
    // market_stock_list=1.000001
    // market_stock_list=0.399001
    // market_stock_list=1.000300

    if(market == 1 && code.indexOf('000') == 0 && code != '000300'){
      code = '000001'
    }
    if(market == 0 && code.indexOf('399') == 0){
      code = '399001'
    }
    if(market == 47 && (code == '800000' || code == '800001')){
      market = 1
      code = '000001'
    }    

    let params = {}
    if(isBK){
      params = {
        bk_code:code
      }
    }else{
      params = {
        market_stock_list:market + "."+code
      }
    }
    return $.ajax({
      url: "//np-anotice-stock.eastmoney.com/api/security/ann?cb=?",
      type: "GET",
      data:{
        client_source:"wap",
        page_index:pageNumber,
        page_size:pageSize,
        ...params,
      },
      dataType: "jsonp",
    }).then((v) => {
      if (v.success == 1 || v.code == 1) {
        return v.data
      } else {
        return null
      }
    })
  },
   /**
   * 获取股票研报（返回全数据）
   */
  async getStockReports_new(
    code: string,
    market: number,
    pageNumber: number,
    pageSize: number,
    isBK:boolean
  ): Promise<null | {
    condition: string
    news: Array<object>
  }> {
    let params = {}
    if(isBK){
      params = {
        bk_code:code
      }
    }else{
      params = {
        stock_list:market+"."+code
      }
    }
    return $.ajax({
      url: "//np-areport-wap.eastmoney.com/api/security/rep?cb=?",
      type: "GET",
      data:{
        client_source:"wap",
        page_index:pageNumber,
        page_size:pageSize,
        report_type:"0,1",
        ...params,
      },
      dataType: "jsonp",
    }).then((v) => {
      if (v.success == 1 || v.code == 1) {
        return v.data
      } else {
        return null
      }
    })
  },

   /**
   * 根据股票的新闻或者公告研报
   * @param  
   * @param type  类别 1 研报 2 公告
   * @param condition
   */
  async getStockNewsOrNotice(code:string, market:string, type:number, pageNumber: number, pageSize: number ,isBK:boolean):Promise<null|{
    condition:string,
    news: Array<object>
  }>{

    let urlArr = ['//np-listapi.eastmoney.com/comm/wap/getListInfo?cb=callback&client=wap&type=1','//np-areport-wap.eastmoney.com/api/security/rep?cb=?&client_source=wap','//np-anotice-stock.eastmoney.com/api/security/ann?cb=?&client_source=wap']
    let url = ''
    if(isBK){
        if(type == 1){
            url = urlArr[type] + `&page_index=${pageNumber}&page_size=${pageSize}&bk_code=${code}`
        }else if(type == 2){
            url = urlArr[type] + `&page_index=${pageNumber}&page_size=${pageSize}&bk_code=${code}`
        }else if(type == 0){
            url = urlArr[type] + `&mTypeAndCode=${market}.${code}&pageSize=${pageSize}&pageIndex=${pageNumber}`
        }
    }else{
        if(type == 1){
            url = urlArr[type] + `&page_index=${pageNumber}&page_size=${pageSize}&stock_list=${market}.${code}`
        }else if(type == 2){
            url = urlArr[type] + `&page_index=${pageNumber}&page_size=${pageSize}&market_code=${market}&stock_list=${code}`
        }else if(type == 0){
            url = urlArr[type] + `&mTypeAndCode=${market}.${code}&pageSize=${pageSize}&pageIndex=${pageNumber}`
        }
    }

    return $.ajax({
      url: url,
      type: 'GET',
      dataType: 'jsonp'
    }).then(v=>{ 
      if(v.data && v.data.list && v.data.list instanceof Array){
        return v.data.list
      }
      else{
        return []
      }
    })
  }
}